<template>
    <div style="height: 70vh;" class="d-flex flex-column justify-content-start mt-3 p-3">
        <div class="d-flex justify-content-start align-items-center px-2 w-100">
            <div
                class="w-100 img-grid bg-img-contain d-flex justify-content-center align-items-center mx-2 my-2 cursor-pointer"
                :class="{
                    active: selectedImage == img && !img.isLoading,
                }"
                v-for="(img, i) in images"
                :key="i"
                style="
                    width: 100px !important;
                    height: 100px !important;
                    background-color: #f4f4f4;
                    overflow: hidden;
                "
            >
                <!-- <Skeletor class="label" style="width: 100%; height: 150px; border-radius: 0;" /> -->
                <img
                    v-if="!img.isLoading"
                    class=""
                    :src="`${img}`"
                    style="
                        width: 100px !important;
                        height: auto !important;
                        transition: all 0.2s ease-in-out;
                    "
                    alt=""
                    @click="setImage(img)"
                />
            </div>
            <!-- <div class="w-100 img-grid bg-img-contain mx-1 cursor-pointer" v-for="(img, i) in 4" :key="i">
                <Skeletor class="label" style="width: 100%; height: 150px; border-radius: 0;" />
            </div> -->
        </div>
        
        <CommonsVueZoomer
            ref="zoomer"
            style="width: 100%; height: 100%;"
            :aspect-ratio="imageAspectRatio"
            :max-scale="10"
            :zooming-elastic="false"
            :zoomed.sync="zoomed"
        >
            <img :src="selectedImage" style="object-fit: contain; width: 100%; height: 100%;" @load="onImageLoad">
        </CommonsVueZoomer>
        <div class="d-flex justify-content-start align-items-center px-2 pt-2 w-100">
            <!-- <i class="fa fa-magnifying-glass"></i> -->
            <div style="padding: 15px; cursor: pointer;" @click="zoomIn()">
                <svg width="24" height="24" xmlns="http://www.w3.org/2000/svg" fill-rule="evenodd" clip-rule="evenodd"><path d="M15.853 16.56c-1.683 1.517-3.911 2.44-6.353 2.44-5.243 0-9.5-4.257-9.5-9.5s4.257-9.5 9.5-9.5 9.5 4.257 9.5 9.5c0 2.442-.923 4.67-2.44 6.353l7.44 7.44-.707.707-7.44-7.44zm-6.353-15.56c4.691 0 8.5 3.809 8.5 8.5s-3.809 8.5-8.5 8.5-8.5-3.809-8.5-8.5 3.809-8.5 8.5-8.5zm-4.5 8h4v-4h1v4h4v1h-4v4h-1v-4h-4v-1z"/></svg>
            </div>
            <div style="padding: 15px; cursor: pointer;" @click="zoomOut()">
                <svg width="28" height="28" clip-rule="evenodd" fill-rule="evenodd" stroke-linejoin="round" stroke-miterlimit="2" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="m15.97 17.031c-1.479 1.238-3.384 1.985-5.461 1.985-4.697 0-8.509-3.812-8.509-8.508s3.812-8.508 8.509-8.508c4.695 0 8.508 3.812 8.508 8.508 0 2.078-.747 3.984-1.985 5.461l4.749 4.75c.146.146.219.338.219.531 0 .587-.537.75-.75.75-.192 0-.384-.073-.531-.22zm-5.461-13.53c-3.868 0-7.007 3.14-7.007 7.007s3.139 7.007 7.007 7.007c3.866 0 7.007-3.14 7.007-7.007s-3.141-7.007-7.007-7.007zm3.256 6.26h-6.5c-.414 0-.75.336-.75.75s.336.75.75.75h6.5c.414 0 .75-.336.75-.75s-.336-.75-.75-.75z" fill-rule="nonzero"/></svg>
            </div>
            <!-- <button @click="zoomIn()">Zoom in</button><button @click="zoomOut()">Zoom out</button> -->
        </div>
        <!-- <button @click="$refs.zoomer.zoomIn()">+</button> -->
    </div>
</template>

<!-- <script>
import VueZoomer from 'vue-zoomer'
export default {
components: {
    VZoomer: VueZoomer.Zoomer,
    VZoomerGallery: VueZoomer.Gallery,
},
  data () {
    return {
      zoomed: false,
      imageAspectRatio: 1,
    }
  },
  methods: {
    onImageLoad(e) {
      const img = e.target
      this.imageAspectRatio = img.naturalWidth / img.naturalHeight
    },
  },
}
</script> -->

<script setup>
const props = defineProps({
    images: {
        type: Array
    }
});

const zoomer = ref(null);
const gallery = ref(null);
const selIndex = ref(0);
const zoomed = ref(false);
const imageAspectRatio = ref(1);
const selectedImage = ref("");

const zoomIn = () => {
    zoomer.value.zoomIn();
}

const zoomOut = () => {
    zoomer.value.zoomOut();
}

const zoomInGallery = () => {
    console.log("gallery.value");
    console.log(gallery.value);
    console.log(gallery.value.zoomIn());
    // zoomer.zoomIn()
}

const setImage = (img) => {
    selectedImage.value = img;
}

const onImageLoad = (e) => {
    const img = e.target
    imageAspectRatio.value = img.naturalWidth / img.naturalHeight
};

watch(() => props.images, () => {
    if (props.images?.length && !selectedImage.value.length) {
        selectedImage.value = props.images[0];
    }
})
onMounted( () => {})
</script>
<style lang="scss">
.svelte-h1 {
    line-height: 1em;
    padding: 1em .9em .75em;
    margin: 0;
    font-weight: 400;
    text-align: center;
}

.svelte-p {
    display: block;
    font-size: 20px;
    text-align: center;
    line-height: 1.2em;

}

.svelte-span {
    font-weight: 400;
    font-size: 14px;
    line-height: 1.428571429;
    color: #222;
}
.svelte-scroll {
    overflow: scroll;
    height: 250px;
}
</style>
